'use client'

import React from 'react'

// Renders trusted HTML and starts the `autoplay` videos in it. On a client render
// (navigation, a new page of a feed) React parses `dangerouslySetInnerHTML` into an
// element that is not yet in the document; a video served from the browser cache becomes
// ready right there, and Chrome does not autoplay a detached video nor retry once it is
// attached, so it stays on its first frame.
export function HtmlContent({ html }: { html: string }) {
    const ref = React.useRef<HTMLDivElement>(null)

    // biome-ignore lint/correctness/useExhaustiveDependencies: new HTML brings new video elements
    React.useEffect(() => {
        for (const video of ref.current?.querySelectorAll('video[autoplay]') ?? []) {
            if (!(video instanceof HTMLVideoElement) || !video.paused) {
                continue
            }

            // A refusal (autoplay disabled, power saving) leaves the first frame on screen,
            // exactly as a refused native autoplay would; there is nothing else to do.
            video.play().catch(() => undefined)
        }
    }, [html])

    return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />
}
